import { differenceInDays, format, isValid, parseISO } from 'date-fns'

const OPS_DATETIME_FORMAT = 'MMM d, yyyy - hh:mm:ss a'
const OPS_DATETIME_SHORT_FORMAT = 'MMM d, yyyy, h:mm a'

/** Normalize API `ready` values (ISO string, unix seconds/ms) to ISO string */
export function normalizeOpsDateInput(value: unknown): string | null {
  if (value == null || value === '') return null

  if (typeof value === 'number' && Number.isFinite(value)) {
    const ms = value > 0 && value < 1e12 ? value * 1000 : value
    const date = new Date(ms)
    return Number.isNaN(date.getTime()) ? null : date.toISOString()
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) return null
    if (/^\d+$/.test(trimmed)) {
      return normalizeOpsDateInput(Number(trimmed))
    }
    const parsed = parseISO(trimmed)
    return isValid(parsed) ? parsed.toISOString() : null
  }

  return null
}

export function formatOpsDateTime(iso: string): string {
  return format(parseISO(iso), OPS_DATETIME_FORMAT)
}

/** Compact datetime for dense UI (card footer) — seconds live in tooltip */
export function formatOpsDateTimeShort(iso: string): string {
  return format(parseISO(iso), OPS_DATETIME_SHORT_FORMAT)
}

export function formatRelativeSince(iso: string): string {
  const days = differenceInDays(new Date(), parseISO(iso))
  if (days === 0) return 'Today'
  if (days === 1) return '1 day ago'
  return `${days} days ago`
}
